import React from "react";
import Datetime from 'react-datetime';

const DateFilter = ({onChange}) => {

  const handleChange = (val)=> {
    return onChange(val.toDate().toISOString().split('T')[0]);
  };

  return <Datetime utc={true} closeOnSelect={true} inputProps={{ className: 'form-control' }} onChange={val => handleChange(val)} />;
};

export default DateFilter;
